/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Newitems1Inputs */

const he_nav_newitems1 = /** @type {(inputs: Nav_Newitems1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מוצרים חדשים`)
};

const en_nav_newitems1 = /** @type {(inputs: Nav_Newitems1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New Items`)
};

/**
* | output |
* | --- |
* | "New Items" |
*
* @param {Nav_Newitems1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const nav_newitems1 = /** @type {((inputs?: Nav_Newitems1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Newitems1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_nav_newitems1(inputs)
	return en_nav_newitems1(inputs)
});
export { nav_newitems1 as "nav_newItems" }